"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.larger = void 0;
exports.larger = {
    card: "10",
    flag: "6",
    popover: "6",
};
exports.default = exports.larger;
